import request from "@/utils/request"
//用户申请提现
export function applyCash(data) {
  return request({
    url:'/userBalance/applyCash',
    method:'post',
    data
  })
}
//收益报表
export function getIncomeStatement(data) {
  return request({
    url:'/userBalance/getIncomeStatement',
    method:'post',
    data
  })
}
//获取用户余额记录
export function getUserBalanceLog(data) {
  return request({
    url:'/userBalance/getUserBalanceLog',
    method:'post',
    data
  })
}
//获取用户提现记录
export function getUserCashList(data) {
  return request({
    url:'/userBalance/getUserCashList',
    method:'post',
    data
  })
}